import styled from '@emotion/styled';

export const FormContainer = styled.form`
    width: 100%;
`;
